
import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Grid, Label, Segment } from 'semantic-ui-react';
import TableDropdown from 'shared/TableDropdown';
import usersActions from 'actions/users';
import { Button, Icon, Notification, Person, STATUS_TYPES } from 'dyl-components';
import "./AddBillingContactForm.scss"

export default function AddBillingContactForm({ onClose }) {

    const dispatch = useDispatch();

    const { control, formState: { isValid, isDirty }, handleSubmit, reset } = useForm({
        mode: "onChange",
        defaultValues: {
            billing_contacts: []
        },
    });

    const isAddingBillingContacts = useSelector((state) => state?.users?.isAddingBillingContacts || false);

    const SearchResultsRender = ({ results, count, value, onChange }) => {

        const onSelect = (e, access) => {
            access = access || []
            onChange(e, [...value, access]);
        }

        const users = results || []

        return (
            <Segment className='BillingContactForm'>
                <Grid className='ResultsGrid' container>
                    {count > 0 ? <>
                        {(users).length > 0 && (
                            <>
                                {users.map(row => {
                                    const isSelected = value?.find(selectedusers => selectedusers.user_id === row.user_id);
                                    const isBillingContact = row?.is_billing_contact
                                    return (
                                        <Grid.Row className='ResultsGrid__HeaderRow'   >
                                            <Grid.Column width={'12'} ><Person username={row?.name} email={row?.email} popup={false} />
                                            </Grid.Column>
                                            <Grid.Column width={'4'}>
                                                <Button primary
                                                    disabled={isSelected || isBillingContact}
                                                    onClick={_ => { onSelect(_, row); }}
                                                    type="button"
                                                >Add</Button>
                                            </Grid.Column>
                                        </Grid.Row>
                                    );
                                })}
                            </>
                        )}
                    </> : (
                        <Grid.Row className='ResultsGrid__HeaderRow'>
                            <Grid.Column width={16}>
                                No results found
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            </Segment>
        );
    }

    const SelectionRender = ({ value, onChange }) => {
        const onDeleteAccess = (_, id) => {
            onChange(_, [
                ...value.filter(selectedAccess => selectedAccess.user_id !== id)
            ]);
        }

        return (
            <div className='SequenceSettingsTab__SequenceAccessSelection'>
                {value.map(user => (
                    <div className='SelectedSequenceAccess'>
                        <Label className='SelectedSequenceAccess__Label' basic>
                            {user.name}
                            <Label.Detail><Icon className='fa-solid fa-xmark' onClick={_ => { onDeleteAccess(_, user.user_id) }} /></Label.Detail>
                        </Label>
                    </div>
                ))}
            </div>
        );
    }

    const onSearchAction = async (search) => {
        if (search?.trim()) {
            try {

                const data = await dispatch(usersActions.searchBillingContacts(search?.length > 0 ? { search: search } : {}));
                return {
                    data: data?.map((ele) => {
                        return {
                            name: ele?.user_full_name,
                            email: ele?.user_email,
                            user_id: ele?.user_id,
                            is_billing_contact: ele?.is_billing_contact
                        }
                    }), count: data?.length
                };
            } catch (error) {
                console.log('error: ', error);

            }
        }
    }
    
    const onSave = async (form_values) => {
        const { billing_contacts } = form_values
        try {
            await dispatch(usersActions.addBillingContacts({
                user_ids: billing_contacts?.map((ele) => {
                    return ele?.user_id
                })
            }))
            reset()
            onClose()
            Notification.alert('Successfully added billing contacts!', STATUS_TYPES.SUCCESS);
            dispatch(usersActions.getBillingContacts());
        } catch (error) {
            console.log('error: ', error);
            Notification.alert('Failed to add billing contact!', STATUS_TYPES.ERROR);
        }

    }

    return (
        <Form onSubmit={handleSubmit(onSave)}>
            <Form.Group widths="equal">
                <Controller
                    name="billing_contacts"
                    control={control}
                    render={({
                        field: { name, value, onChange },
                        fieldState: { error },
                    }) => (
                        <Form.Field
                            control={TableDropdown}
                            label="User"
                            value={value}
                            onChange={(e, newValue) => {
                                e.stopPropagation()
                                onChange({ target: { name, value: newValue } });
                            }}
                            isSelectionVisible={value?.length > 0}
                            SelectionRender={SelectionRender}
                            SearchResultsRender={SearchResultsRender}
                            onSearchAction={onSearchAction}
                            searchPlaceholder="Search by user"
                            errorMessage={error && error.message}
                            required
                        />
                    )}
                />
            </Form.Group>
            <div className="BillingContactForm__SaveButton">
                <Button
                    disabled={!isValid || !isDirty}
                    primary
                    loading={isAddingBillingContacts}
                >
                    Save
                </Button>
            </div>
        </Form>
    )
}
